import { Trans, useTranslation } from "react-i18next";
import { ExamConfirmationDialog } from "./ExamConfirmationDialog";

interface SubmitExamModalProps {
  onCancel?: () => void;
  onContinue?: () => void;
  onOpenChange: (open: boolean) => void;
  open: boolean;
}

export default function SubmitExamModal({
  onCancel = () => {},
  onContinue = () => {},
  onOpenChange,
  open,
}: SubmitExamModalProps) {
  const { t } = useTranslation();

  return (
    <ExamConfirmationDialog
      body={
        <Trans
          components={{ strong: <strong className="font-bold" /> }}
          i18nKey="test.submit_confirm_body_detailed"
        />
      }
      cancelLabel={t("common.cancel")}
      confirmLabel={t("test.submit_see_results")}
      onCancel={onCancel}
      onConfirm={onContinue}
      onOpenChange={onOpenChange}
      open={open}
      title={t("test.submit_confirm_title_simple")}
    />
  );
}
